import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface PoliciesIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function PoliciesIcon({ className, color = 'white', ...props }: PoliciesIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0.875 18V6C0.875 3.72183 2.72183 1.875 5 1.875H9.58643C10.0795 1.87515 10.5546 2.04703 10.9326 2.35693L11.0879 2.49756L13.4653 4.875H18.9995C21.2777 4.875 23.1245 6.72183 23.1245 9V18C23.1245 20.2782 21.2777 22.125 18.9995 22.125H5C2.72183 22.125 0.875 20.2782 0.875 18ZM3.125 18C3.125 19.0355 3.96447 19.875 5 19.875H18.9995C20.035 19.875 20.8745 19.0355 20.8745 18V9C20.8745 7.96447 20.035 7.125 18.9995 7.125H13.4141C12.9209 7.12497 12.446 6.95292 12.0679 6.64307L11.9111 6.50244L9.53369 4.125H5C3.96447 4.125 3.125 4.96447 3.125 6V18Z"
        fill={color}
      />
      <path
        d="M14.3755 11.8852L11.9995 10.6973L9.62501 11.8852V13.6226L9.63966 13.791C9.70994 14.1978 10.0288 14.6973 10.6167 15.2412C11.0877 15.6769 11.6166 16.0331 11.9995 16.2666C12.3825 16.0331 12.9125 15.6772 13.3838 15.2412C14.0555 14.6198 14.3755 14.0559 14.3755 13.6226V11.8852ZM16.6255 13.6226L16.6138 13.8848C16.5082 15.1823 15.6396 16.2201 14.9116 16.8935C14.2973 17.4618 13.6323 17.9085 13.1626 18.1943L12.7671 18.4258C12.3491 18.6583 11.8537 18.6868 11.4165 18.5122L11.2334 18.4258C10.8168 18.194 9.90833 17.6515 9.08887 16.8935C8.36085 16.2201 7.4908 15.1824 7.38526 13.8848L7.37501 13.6226V11.4985C7.37519 10.8833 7.72269 10.3206 8.27296 10.0454L11.273 8.5454L11.4487 8.4707C11.8051 8.34213 12.1954 8.34202 12.5518 8.4707L12.7261 8.5454L15.7261 10.0454L15.9238 10.1611C16.3591 10.4616 16.6253 10.9602 16.6255 11.4985V13.6226Z"
        fill={color}
      />
    </svg>
  );
}
